import React from 'react'
import { cva } from 'class-variance-authority'
import { mergeClasses } from '../../../utils/mergeClasses'

const badgeVariants = cva(
    // `tw-border-solid` is required — preflight is disabled, so a bare
    // `tw-border` only sets width and the border won't render.
    'tw-inline-flex tw-h-5 tw-w-fit tw-shrink-0 tw-items-center tw-justify-center tw-gap-1 tw-overflow-hidden tw-rounded-full tw-border tw-border-solid tw-border-transparent tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium tw-whitespace-nowrap tw-transition-all [&>svg]:tw-pointer-events-none [&>svg]:!tw-size-3',
    {
        variants: {
            variant: {
                default: 'tw-bg-primary tw-text-primary-foreground',
                secondary: 'tw-bg-secondary tw-text-secondary-foreground',
                destructive:
                    'tw-bg-destructive/10 tw-text-destructive dark:tw-bg-destructive/20',
                outline: 'tw-border-border tw-text-foreground',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
)

const Badge = React.forwardRef(
    ({ className, variant = 'default', ...props }, ref) => {
        return (
            <span
                ref={ref}
                data-slot="badge"
                data-variant={variant}
                className={mergeClasses(badgeVariants({ variant }), className)}
                {...props}
            />
        )
    }
)
Badge.displayName = 'Badge'

export { Badge, badgeVariants }
